//
// Copyright (c) 2023 Emplifi, Inc.
//

// @ts-ignore
import i18next from "i18n/i18n";
import { ButtonView, Plugin } from "ckeditor5";

// @ts-ignore
import "./css/accordionUi.css";

// @ts-ignore
import accordionIcon from "img/svg/accordion.svg";

export default class AccordionUi extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "AccordionUi";
  }

  init() {
    this._addToolbarButtons();
  }

  private _addToolbarButtons() {
    this.editor.ui.componentFactory.add("accordion", (locale) => {
      const command = this.editor.commands.get("insertAccordion");
      const button = new ButtonView(locale);
      button.set({
        isEnabled: true,
        label: i18next.t("ckeditor.accordion.buttonName"),
        icon: accordionIcon,
        tooltip: true,
      });
      if (command) {
        button.bind("isEnabled").to(command);
      }
      this.listenTo(button, "execute", () => this.editor.execute("insertAccordion"));
      return button;
    });
    this.editor.ui.componentFactory.add("addAccordionSection", (locale) => {
      const command = this.editor.commands.get("addAccordionSection");
      const button = new ButtonView(locale);
      button.set({
        isEnabled: true,
        label: i18next.t("ckeditor.accordion.addSection"),
        withText: true,
      });
      if (command) {
        button.bind("isEnabled").to(command);
      }
      this.listenTo(button, "execute", () => this.editor.execute("addAccordionSection"));
      return button;
    });
    this.editor.ui.componentFactory.add("removeAccordionSection", (locale) => {
      const command = this.editor.commands.get("removeAccordionSection");
      const button = new ButtonView(locale);
      button.set({
        isEnabled: true,
        label: i18next.t("ckeditor.accordion.removeSection"),
        withText: true,
      });
      if (command) {
        button.bind("isEnabled").to(command);
      }
      this.listenTo(button, "execute", () => this.editor.execute("removeAccordionSection"));
      return button;
    });
  }
}
